export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6572.52f6f2f6.jpg";